import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20illustration%20of%20diverse%20people%20chatting%20around%20a%20long%20wooden%20table%20under%20green%20trees%2C%20cozy%20community%20gathering%2C%20soft%20golden%20afternoon%20light%2C%20painterly%20artistic%20style%2C%20green%20and%20cream%20tones&width=1600&height=600&seq=gt-cta-bg&orientation=landscape"
          alt="瓜田社区居民围坐聊天的插画"
          title="加入瓜田社区 - 发帖互动回帖讨论"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/65 to-foreground-950/35" />
        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-6 py-12 md:px-12 md:py-16">
            <div className="max-w-xl">
              <span className="text-xs font-medium tracking-widest text-secondary-300">
                JOIN US
              </span>
              <h2 className="mt-2 text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                今晚有空吗？来瓜田聊两句
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200/90">
                今日话题每天都在等你接话，热帖榜单每分钟都在刷新。不用准备，想到什么就说什么，这里有人认真听。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/topics"
                  className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-quill-pen-line" />
                  发一条新帖
                </Link>
                <Link
                  to="/about"
                  className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 text-sm text-background-100 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-information-line" />
                  了解瓜田社区
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}